<template>
  <div style="margin-bottom:25px;">
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column prop="data" label="" align="center" width="280"></el-table-column>
      <el-table-column
        prop="data2"
        label="本基金"
        width="280"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="data3"
        label="同类排名"
        width="280"
        align="center"
      ></el-table-column>
      <el-table-column prop="" label="等级" min-width="580">
        <template slot-scope="scope">
            <div class="box">
                <div class="bg_box">
                <div class="bg1 border_radius_left" :class="{bg2:scope.row.data4 < 1}"></div>
                <div class="bg1" :class="{bg2:scope.row.data4 < 2}"></div>
                <div class="bg1" :class="{bg2:scope.row.data4 < 3}"></div>
                <div class="bg1" :class="{bg2:scope.row.data4  < 4}"></div>
                <div class="bg1 border_radius_right" :class="{bg2:scope.row.data4 < 5}"></div>
            </div>
            <div class="text_box">很高</div>
            </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [
        {
          data: "基金性价比-夏普比率",
          data2: "1.13",
          data3: "102/1772",
          data4: "5",
        },
        {
          data: "获取收益水平-阿尔法系数",
          data2: "31.0%",
          data3: "135/1772",
          data4: "5",
        },
        {
          data: "风险控制水平",
          data2: "18.8%",
          data3: "383/2165",
          data4: "4",
        },
        {
          data: "风险控制水平-波动率",
          data2: "21.6%",
          data3: "631/2911",
          data4: "4",
        },
        {
          data: "风险控制水平-下行风险",
          data2: "10.8%",
          data3: "274/1792",
          data4: "4",
        },
        {
          data: "风险控制水平-最大回撤",
          data2: "-13.6%",
          data3: "245/1792",
          data4: "4",
        },
      ],
    };
  },
};
</script>

<style scoped>
.el-table /deep/ th {
  background-color: #f8f9fd !important;
  text-align: center;
  height: 56px;
}
.el-table /deep/ td {
  height: 56px;
}
.bg1{
    width: 44px;
	height: 8px;
    background-color: rgba(252,173,42,1);
    margin-left: 3px;
    margin-top: 4px;
}
.bg2{
    background-color: rgba(252,173,42,.12);
}
.border_radius_left{
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}
.border_radius_right{
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}
.box{
    display: flex;
    justify-content: center;
}
.bg_box{
    display: flex;
}
.text_box{
    margin-left: 6px;
    font-size: 16px;
	line-height: 16px;
	color: #fcad2a;
}
</style>